"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./datatable.component"));
__export(require("./header"));
__export(require("./body"));
__export(require("./footer"));
__export(require("./columns"));
__export(require("./row-detail"));
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /var/www/dnata-cerf-front-end/releases/20200326161233/~/@swimlane/ngx-datatable/release/components/index.js
// module id = 3T/J
// module chunks = 4